import { Fragment } from "react";
import {
  getIconSrc,
  getInitialsIconSrc,
} from "../../../../utils/images/iconUtils";
import CategoryPill from "../../badges/CategoryPill";

function TransactionCard({ transaction, onClick }) {
  return (
    <Fragment>
      <div className="urt-card" onClick={onClick} style={{ cursor: "pointer" }}>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              width: "70%",
            }}
          >
            <img
              className="urt-card-icon"
              src={
                transaction.merchant_icon
                  ? getIconSrc(transaction.merchant_icon)
                  : getInitialsIconSrc(transaction.merchant)
              }
              alt={transaction.merchant}
            />
            <div>
              <p className="urt-card-merchant margin-reset padding-reset">
                {transaction.merchant}
              </p>
              <span className="urt-card-date">{transaction.date}</span>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "end", width: "30%" }}>
            <strong className="urt-card-amount">{transaction.amount}</strong>
          </div>
        </div>
        <CategoryPill
          label={transaction.category}
          categoryCode={transaction.category_code || transaction.category_value}
          categoryPrimary={transaction.category_primary}
          categoryDetailed={transaction.category_detailed}
        />
      </div>
    </Fragment>
  );
}

export default TransactionCard;
